import * as LoyaltyDialogResult from "@ori-events/loyalty-dialog-result";
import * as AddToBasket from "@ori-events/add-to-basket";
import { RequestUrl } from "../models";
import addToBasket from "../helpers/addToBasket";
export default (function (event) {
    if (LoyaltyDialogResult.isLoyaltyCloseResult(event.detail.result)) {
        return false;
    }
    if (LoyaltyDialogResult.isLoyaltyBuyForPointsResult(event.detail.result)) {
        var _a = event.detail, catalogueItemId = _a.catalogueItemId, choiceId = _a.choiceId, itemCode = _a.itemCode, quantity = _a.quantity, placement = _a.placement;
        return addToBasket(RequestUrl.REQUEST_ADD_TO_BASKET_FOR_POINTS, {
            itemCode: itemCode,
            quantity: quantity,
            choiceId: choiceId,
            catalogueItemId: catalogueItemId,
            placement: placement,
        }, AddToBasket.Method.BUY_FOR_POINTS);
    }
    if (LoyaltyDialogResult.isLoyaltyBuyForMoneyResult(event.detail.result)) {
        var _b = event.detail, itemCode = _b.itemCode, quantity = _b.quantity, originalItemCode = _b.originalItemCode, replacementType = _b.replacementType, placement = _b.placement;
        return addToBasket(RequestUrl.REQUEST_ADD_TO_BASKET_FOR_MONEY, {
            itemCode: itemCode,
            quantity: quantity,
            originalItemCode: originalItemCode,
            replacementType: replacementType,
            placement: placement,
        }, AddToBasket.Method.BUY_FOR_MONEY);
    }
    return false;
});
